module.exports = __webpack_public_path__ + "img/circle2.593e7392.gif";